// Lib
import { createAction } from 'redux-actions';

// Types
import { GqlGqlChatEntityType } from '@app-types/index';

// Only schema-supported entity contexts are sent to the assistant.
export type AIContextEntity = GqlGqlChatEntityType | 'PROPERTY';

const SUPPORTED_CHAT_ENTITIES = new Set<string>(
  Object.values(GqlGqlChatEntityType),
);

export const isSupportedChatEntity = (
  entity?: AIContextEntity | null,
): entity is GqlGqlChatEntityType =>
  !!entity && SUPPORTED_CHAT_ENTITIES.has(entity);

export interface AIContextPayload {
  entity: AIContextEntity;
  id: string;
  name: string;
}

export const SetAIContext = createAction<AIContextPayload>('SET_AI_CONTEXT');
export const ClearAIContext = createAction('CLEAR_AI_CONTEXT');
